import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { isCancelledMeetingItemClass } from 'mini-meeting-invite/lib/utils/isCancelledMeetingItemClass';
import { isMeetingRequest } from 'mini-meeting-invite/lib/utils/isMeetingRequest';

/**
 * Determines whether the item should show the RSVP. This is based on the partial item and does
 * only the basic checks.
 */
export const shouldShowRSVPBasedOnInitialCheck = (
    itemId: string,
    itemClass: string,
    tableView: TableView
) => {
    // FolderId might be null (i.e. search)
    // We will show a RSVP placeholder for these scenarios and call GetItem
    // Depending on the parent folder of the item, we will hide the button
    const folderName = tableView?.tableQuery?.folderId
        ? folderIdToName(tableView.tableQuery.folderId)
        : null;
    const isItemInRightFolderToShowRSVP = !!(
        folderName &&
        folderName !== 'deleteditems' &&
        folderName !== 'sentitems'
    );

    const isItemMeetingType = !!(
        itemClass &&
        (isMeetingRequest(itemClass) || isCancelledMeetingItemClass(itemClass))
    );

    if (itemId && isItemInRightFolderToShowRSVP && isItemMeetingType) {
        return true;
    }

    return false;
};
